import React, { memo } from 'react';
import { grey } from 'sushiweb/tokens/color';
import { DownTriangleSmall, UpTriangleSmall } from 'sushiweb/Icons';
import { Tooltip } from '../../../UiKit';

export const ToggleExpanded = memo(({ isExpanded, onClick }) => {
  return (
    <Tooltip
      position={isExpanded ? 'bottom' : 'top'}
      title={
        isExpanded ? (
          <DownTriangleSmall size={24} color={grey.z900} onClick={onClick} />
        ) : (
          <UpTriangleSmall size={24} color={grey.z900} onClick={onClick} />
        )
      }
      border={false}
      label={isExpanded ? 'Minimize' : 'Maximize'}
    />
  );
});

ToggleExpanded.defaultProps = {
  isExpanded: true,
  onClick: () => {},
};
